import React from 'react';
import Culture from '../components/sections/Culture';

const CulturePage = () => {
    return (
        <div style={{ paddingTop: '60px' }}>
            <Culture />
        </div>
    );
};

export default CulturePage;
